"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storefront_client_1 = require("@rechargeapps/storefront-client");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var recharge_storefront_1 = require("../../misc/recharge-storefront");
var ts_utils_1 = require("../../misc/ts-utils");
var fetch_products_by_collection_name_1 = __importDefault(require("../../utils/fetch-products-by-collection-name"));
var fetch_user_geolocation_1 = require("../../utils/fetch-user-geolocation");
var storefront_client_2 = require("../../utils/storefront-client");
var email_before_freebie_1 = require("../bundler/components/email-before-freebie");
var stepper_1 = __importDefault(require("../shared-components/stepper"));
var bundler_unavailable_modal_1 = __importDefault(require("./components/bundler-unavailable-modal"));
var cloudfront_bundle_config_1 = require("./data/cloudfront-bundle-config");
var discount_addons_1 = __importDefault(require("./steps/discount-addons"));
var freebie_addons_1 = __importDefault(require("./steps/freebie-addons"));
var patterns_1 = __importDefault(require("./steps/patterns"));
var review_1 = __importDefault(require("./steps/review"));
var sizes_1 = __importDefault(require("./steps/sizes"));
var bundle_1 = require("./store/bundle");
var bundle_input_1 = require("./store/bundle-input");
var fetch_main_bundle_product_1 = require("./utils/fetch-main-bundle-product");
var Spinner = function (_a) {
    var className = _a.className, style = _a.style;
    return (react_1.default.createElement("svg", { className: className, style: __assign({ height: '1rem', width: '1rem' }, style), xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24' },
        react_1.default.createElement("circle", { className: 'opacity-25', cx: '12', cy: '12', r: '10', stroke: 'currentColor', strokeWidth: '2' }),
        react_1.default.createElement("path", { className: 'opacity-75', fill: 'currentColor', d: 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z' })));
};
var NavBar = function (_a) {
    var nextButtonEnabled = _a.nextButtonEnabled, backButtonEnabled = _a.backButtonEnabled, nextButtonHidden = _a.nextButtonHidden, backButtonHidden = _a.backButtonHidden, refCallback = _a.refCallback, maxWidth = _a.maxWidth, goNext = _a.goNext, goBack = _a.goBack, beforeGoNext = _a.beforeGoNext, nextText = _a.nextText, backText = _a.backText, beforeGoBack = _a.beforeGoBack, nextLoading = _a.nextLoading;
    var handleNextClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allowedToGoNext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!nextButtonEnabled)
                        return [2 /*return*/];
                    if (!beforeGoNext) return [3 /*break*/, 2];
                    return [4 /*yield*/, beforeGoNext()];
                case 1:
                    allowedToGoNext = _a.sent();
                    if (allowedToGoNext)
                        goNext();
                    return [3 /*break*/, 3];
                case 2:
                    goNext();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleBackClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allowedToGoBack;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!backButtonEnabled)
                        return [2 /*return*/];
                    if (!beforeGoBack) return [3 /*break*/, 2];
                    return [4 /*yield*/, beforeGoBack()];
                case 1:
                    allowedToGoBack = _a.sent();
                    if (allowedToGoBack)
                        goBack();
                    return [3 /*break*/, 3];
                case 2:
                    goBack();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // We use an outer container which we bring out of flow by giving it position: fixed coupled with the inner visible bottom bar div to create
    // a bar that is fixed to the bottom. The inner bottom bar is given the same max width as the bundler.
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'z20 position-fixed bottom-0 width-100' },
            react_1.default.createElement("div", { ref: refCallback, className: 'bg-white width-100 padding-horizontal-6 width-100 h-16 flex-container align-justify align-middle border-very-light-pink', style: { maxWidth: maxWidth, boxShadow: '1px 0px 7px rgba(0,0,0,0.1)', borderTopWidth: 1, borderTopStyle: 'solid' } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('padding-vertical-1 padding-horizontal-2 padding-vertical-2 flex-container align-center align-middle rounded-base text-base', backButtonHidden && 'hide', backButtonEnabled ? 'cursor-pointer' : 'cursor-default text-brownish-grey'), "aria-disabled": !backButtonEnabled, onClick: handleBackClick }, backText ? backText : 'Back')),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: (0, classnames_1.default)('padding-vertical-1 padding-horizontal-8 padding-vertical-2 flex-container align-center align-middle rounded-base bg-wisteria text-base text-white', nextButtonHidden && 'hide', nextButtonEnabled ? 'cursor-pointer' : 'cursor-default bg-very-light-pink'), "aria-disabled": !backButtonEnabled, onClick: handleNextClick },
                        nextLoading && (react_1.default.createElement(Spinner, { className: 'animate-spin margin-right-2 text-white', style: {
                                marginBottom: 3, // deal with the fact that the Oakes Grotesk font is not vertically centered
                            } })),
                        nextText ? nextText : 'Next'))))));
};
var DiaperBundlerV2 = function (_a) {
    var _b, _c, _d, _e;
    var stepSettings = _a.stepSettings, specialAnnouncementBanner = _a.specialAnnouncementBanner, rcBundlesForAcquisitionEnabled = _a.rcBundlesForAcquisitionEnabled;
    var _f = __read((0, react_1.useState)(0), 2), activeStepIndex = _f[0], setActiveStepIndex = _f[1];
    var _g = __read((0, react_1.useState)(false), 2), showUnavailableInCountryModal = _g[0], setShowUnavailableInCountryModal = _g[1];
    var domain = process.env.PERMANENT_DOMAIN || window.permanentDomain;
    var llaShop = (function () {
        if (!domain)
            throw new Error('Unable to determine permanent domain');
        if (domain.startsWith('hbca-launched'))
            return 'hbca';
        return 'hbus';
    })();
    var storefrontAccessToken = process.env.STOREFRONT_ACCESS_TOKEN;
    if (!storefrontAccessToken)
        throw new Error('Missing process.env.STOREFRONT_ACCESS_TOKEN');
    // initialize bundle store once the queries are successful
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie, { useErrorBoundary: true });
    var productsQuery = (0, react_query_1.useQuery)(['diaperBundlerV2Products'], function () { return (0, fetch_products_by_collection_name_1.default)('diapers'); }, { useErrorBoundary: true });
    var bundleConfigQuery = (0, react_query_1.useQuery)(['diaperBundlerV2BundleConfig'], function () { return (0, cloudfront_bundle_config_1.fetchBundleConfig)({ cloudfrontUrl: 'https://d25mydkrxair63.cloudfront.net', environment: 'production', shop: llaShop }); }, { useErrorBoundary: true });
    // Our goal here is to either fetch the recharge bundle product or to fetch the subscription_id of our internal main bundle product
    var shopifyProductHandle = (function () {
        if (rcBundlesForAcquisitionEnabled)
            return 'diaper-recharge-bundle';
        return 'diaper-bundle';
    })();
    // TODO: eventually we can probably use getCDNBundleSettings here, but for now, getCDNBundleSettings
    // doesn't include the product's shopify handle, which getDynamicBundleItems requires, so we do this
    var mainBundleProductQuery = (0, react_query_1.useQuery)(['diaperBundlerV2MainBundleProduct', shopifyProductHandle], function () { return (0, fetch_main_bundle_product_1.fetchMainBundleProduct)(shopifyProductHandle, storefrontAccessToken, domain); }, { useErrorBoundary: true, enabled: !!shopifyProductHandle });
    // We only call this function because it has the side effect of initializing the recharge storefront sdk for us.
    // Initializing the storefront sdk is required before calling its fetcher functions.
    var storefrontSdkResult = (0, recharge_storefront_1.useInitRechargeStorefrontSdk)();
    var cdnBundleSettingsQuery = (0, react_query_1.useQuery)(['cdnBundleSettings', rcBundlesForAcquisitionEnabled, (_c = (_b = mainBundleProductQuery.data) === null || _b === void 0 ? void 0 : _b.data.product) === null || _c === void 0 ? void 0 : _c.id, storefrontSdkResult.initialized], 
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    function () { return (0, storefront_client_1.getCDNBundleSettings)((0, storefront_client_2.getIdFromGqlGlobalId)(mainBundleProductQuery.data.data.product.id)); }, { useErrorBoundary: true, enabled: rcBundlesForAcquisitionEnabled && !!((_e = (_d = mainBundleProductQuery.data) === null || _d === void 0 ? void 0 : _d.data.product) === null || _e === void 0 ? void 0 : _e.id) && storefrontSdkResult.initialized });
    var useBundleStore = (0, bundle_1.getBundleStore)().useBundleStore;
    var initializeBundleStore = useBundleStore(function (state) { return state.initialize; });
    var _h = __read((0, react_1.useState)(), 2), defaultToWipesless = _h[0], setDefaultToWipesless = _h[1];
    var useBundleInputStore = (0, bundle_input_1.getBundleInputStore)().useBundleInputStore;
    var presetSizes = useBundleInputStore(function (state) { return state.presetSizes; });
    var presetPreferredPatternGender = useBundleInputStore(function (state) { return state.presetPreferredPatternGender; });
    var presetDiaperSizeRationale = useBundleInputStore(function (state) { return state.presetDiaperSizeRationale; });
    var presetTrainingPantSizeRationale = useBundleInputStore(function (state) { return state.presetTrainingPantSizeRational; });
    var presetPatternStepHeader = useBundleInputStore(function (state) { return state.presetPatternStepHeader; });
    var presetSizeStepHeader = useBundleInputStore(function (state) { return state.presetSizeStepHeader; });
    (0, react_1.useEffect)(function () {
        // We have this commented out because we're not currently persisting the input store to any sort of persistent storage.
        // Since the bundle input store's persistence is asynchronous, we have to wait until it's hydrated before initializing the bundle.
        // We'd also want to disable all of the above queries if the store is already initialized to prevent doing the same work again.
        // if (storeInitialized) return
        // if (!useBundleInputStore.persist.hasHydrated()) return
        var _a;
        // In next.js, we would also return until the router is ready.
        if (!productsQuery.data || !bundleConfigQuery.data || !mainBundleProductQuery.data || !userGeolocationQuery.data || cdnBundleSettingsQuery.isLoading)
            return;
        if (!((_a = mainBundleProductQuery.data.data.product) === null || _a === void 0 ? void 0 : _a.subscriptionId)) {
            throw new Error('Storefront mainBundleProduct is missing or subscription id metafield is missing on product or subscription id metafield is not exposed to Storefront');
        }
        // TODO: print an error message to to DOM rather than throwing an error
        var countryCode = userGeolocationQuery.data.countryCode;
        var isSupportedCountryCode = (0, ts_utils_1.isEnumValue)(countryCode, bundle_1.SUPPORTED_COUNTRY_CODES);
        if (!isSupportedCountryCode) {
            setShowUnavailableInCountryModal(true);
            return;
        }
        var mainBundleProduct = {
            id: (0, storefront_client_2.getIdFromGqlGlobalId)(mainBundleProductQuery.data.data.product.id),
            variants: mainBundleProductQuery.data.data.product.variants.edges.map(function (edge) { return ({
                id: (0, storefront_client_2.getIdFromGqlGlobalId)(edge.node.id),
            }); }),
            handle: mainBundleProductQuery.data.data.product.handle,
            subscriptionId: mainBundleProductQuery.data.data.product.subscriptionId.value,
        };
        // figure out of the url indicates we should let the user select wipesless bundles
        // and pre-select them to get a wipesless bundle
        var wipesless = window.location.search.includes('wpl=1');
        setDefaultToWipesless(wipesless);
        initializeBundleStore({
            countryCode: countryCode,
            products: productsQuery.data.products,
            bundleConfig: bundleConfigQuery.data,
            cdnBundleSettings: cdnBundleSettingsQuery.data || undefined,
            mainBundleProduct: mainBundleProduct,
            rechargeBundlesEnabled: rcBundlesForAcquisitionEnabled,
            wantsWipes: !wipesless,
            presetSizes: presetSizes,
            presetPreferredPatternGender: presetPreferredPatternGender,
            presetDiaperSizeRationale: presetDiaperSizeRationale,
            presetTrainingPantSizeRationale: presetTrainingPantSizeRationale,
            presetPatternStepHeader: presetPatternStepHeader,
            presetSizeStepHeader: presetSizeStepHeader,
        });
    }, [
        initializeBundleStore,
        productsQuery.data,
        bundleConfigQuery.data,
        mainBundleProductQuery.data,
        userGeolocationQuery.data,
        setDefaultToWipesless,
        presetSizes,
        presetPreferredPatternGender,
        presetDiaperSizeRationale,
        presetTrainingPantSizeRationale,
        presetPatternStepHeader,
        presetSizeStepHeader,
        rcBundlesForAcquisitionEnabled,
        cdnBundleSettingsQuery.isLoading,
        cdnBundleSettingsQuery.data,
        // useBundleInputStore.persist,
    ]);
    // deal with the complexities of having a fixed bottom nav
    var _j = __read((0, react_1.useState)(0), 2), navHeight = _j[0], setNavHeight = _j[1];
    var navCallback = (0, react_1.useCallback)(function (ref) {
        var height = (function () {
            if (ref === null)
                return 0;
            return ref.clientHeight;
        })();
        setNavHeight(height);
    }, []);
    var maxWidth = 640;
    // we have to give the content a bottom margin at least equal to the height of the bottom nav, but we choose to also add 20px for a nice look
    var marginBottom = navHeight + 20;
    // create shared props for the nav bar on each step
    var navBarProps = {
        refCallback: navCallback,
        maxWidth: maxWidth,
        goNext: function () { return setActiveStepIndex(function (prev) { return prev + 1; }); },
        goBack: function () { return setActiveStepIndex(function (prev) { return prev - 1; }); },
    };
    var requireEmailBeforeFreebie = (0, react_1.useMemo)(function () {
        return window.location.search.includes(email_before_freebie_1.emailBeforeFreebieUrlInclusion);
    }, []);
    // we manage this state in DiaperBundlerV2 rather than in FreebieAddons so that if the customer goes past the freebies step and then goes back, they won't
    // have to re-enter their email address when FreebieAddons remounts
    var _k = __read((0, react_1.useState)(undefined), 2), collectedEmail = _k[0], setCollectedEmail = _k[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'margin-horizontal-auto bg-white height-100 width-100', style: { maxWidth: maxWidth, marginBottom: marginBottom } },
            react_1.default.createElement("div", { className: 'position-relative z2 height-100 bg-white' },
                react_1.default.createElement(stepper_1.default, { activeIndex: activeStepIndex, onStepClick: setActiveStepIndex },
                    react_1.default.createElement(stepper_1.default.Step, null,
                        react_1.default.createElement(sizes_1.default, { navBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); }, settings: stepSettings.sizes, showWipeslessBundleOption: defaultToWipesless, specialAnnouncementBanner: specialAnnouncementBanner })),
                    react_1.default.createElement(stepper_1.default.Step, null,
                        react_1.default.createElement(patterns_1.default, { navBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); } })),
                    react_1.default.createElement(stepper_1.default.Step, null,
                        react_1.default.createElement(freebie_addons_1.default, { navBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); }, emailBeforeFreebie: {
                                enabled: requireEmailBeforeFreebie,
                                collectedEmail: collectedEmail,
                                setCollectedEmail: setCollectedEmail,
                            } })),
                    react_1.default.createElement(stepper_1.default.Step, null,
                        react_1.default.createElement(discount_addons_1.default, { navBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); }, settings: stepSettings.discountAddons })),
                    react_1.default.createElement(stepper_1.default.Step, null,
                        react_1.default.createElement(review_1.default, { navBar: function (navBarStepProps) { return react_1.default.createElement(NavBar, __assign({}, navBarStepProps, navBarProps)); } }))))),
        react_1.default.createElement(bundler_unavailable_modal_1.default, { isOpen: showUnavailableInCountryModal, message: 'Sorry, the Diaper Bundle is not available in your region.' })));
};
exports.default = DiaperBundlerV2;
